import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=fb5e78d2&scoped=true&"
import script from "./Sent.vue?vue&type=script&lang=js&"
export * from "./Sent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5e78d2",
  null
  
)

export default component.exports